// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__7bguG","focus-visible":"checkbox_focus-visible__x5oiR","wrapper":"checkbox_wrapper__IaUh9"};